import { Decimal } from "decimal.js";

// 加法
export function addition(...args) {
  let result = new Decimal(args[0] || 0);
  for (let i = 1; i < args.length; i++) {
    result = result.add(new Decimal(args[i] || 0));
  }
  return result.toNumber();
}

// 减法
export function subtract(...args) {
  let result = new Decimal(args[0] || 0);
  for (let i = 1; i < args.length; i++) {
    result = result.sub(new Decimal(args[i] || 0));
  }
  return result.toNumber();
}

// 乘法
export function multiply(...args) {
  let result = new Decimal(args[0] || 0);
  for (let i = 1; i < args.length; i++) {
    result = result.mul(new Decimal(args[i] || 0));
  }
  return result.toNumber();
}

// 除法
export function divide(...args) {
  let result = new Decimal(args[0] || 0);
  for (let i = 1; i < args.length; i++) {
    result = result.div(new Decimal(args[i] || 0));
  }
  return result.toNumber();
}

// 解决四舍五入小数toFixed精度丢失
// val 代表值; places 需要精确到几位，默认是2位
export function toFixedDecimal(val, places = 2) {
  const valNew = new Decimal(val || 0);
  const valRes = valNew.toFixed(places);
  return valRes;
}

// 千分位, 价格补.00; s 为数字, n 为保留几个小数点
export function fmoney(s, n) {
  n = n >= 0 && n <= 20 ? n : 2;
  s = toFixedDecimal(parseFloat((s + "").replace(/[^\d.-]/g, "")), n) + "";
  let l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
  r = r == null ? "" : "." + r;
  let t = "";
  if (l[l.length - 1] === "-") {
    //负数不需要分隔号,
    for (let i = 0; i < l.length; i++) {
      if (l[i] === "-") {
        t += l[i] + "";
        continue;
      }
      //不是数组的倒数第二个元素才加"," ["0", "4", "5", "-"]
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length - 1 ? "," : "");
      //i + 1 != l.length会变成-,540.00,因为在5时元素位置2+1为3非数组长度
      //t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
    }
  } else {
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
    }
  }
  return t.split("").reverse().join("") + r;
}
